const SportradarEventTypes = Object.freeze({
  common: {
    match_started: 'Integrations_Sportradar_Event_Match_Started',
    period_start: 'Integrations_Sportradar_Event_Period_Start',
    match_ended: 'Integrations_Sportradar_Event_Match_Ended'
  },
  soccer: {
    break_start: 'Integrations_Sportradar_Event_Break_Start',
    yellow_card: 'Integrations_Sportradar_Event_Yellow_Card',
    yellow_red_card: 'Integrations_Sportradar_Event_Yellow_Red_Card',
    red_card: 'Integrations_Sportradar_Event_Red_Card',
    score_change: 'Integrations_Sportradar_Event_Score_Change'
  },
  nba: {
    period_end: 'Integrations_Sportradar_Event_Period_End',
    ejection: 'Integrations_Sportradar_Event_Ejection'
  },
  nhl: {
    period_end: 'Integrations_Sportradar_Event_Period_End',
    score_change: 'Integrations_Sportradar_Event_Score_Change'
  },
  mlb: {
    period_end: 'Integrations_Sportradar_Event_Period_End',
    key_period_end: 'Integrations_Sportradar_Event_Key_Period_End',
    key_period_start: 'Integrations_Sportradar_Event_Key_Period_Start',
    score_change: 'Integrations_Sportradar_Event_Score_Change',
    homerun: 'Integrations_Sportradar_Event_Homerun',
    strikeout: 'Integrations_Sportradar_Event_Strikeout',
    hit: 'Integrations_Sportradar_Event_Hit',
    out: 'Integrations_Sportradar_Event_Out',
    strike: 'Integrations_Sportradar_Event_Strike',
    walk: 'Integrations_Sportradar_Event_Walk',
    pitch: 'Integrations_Sportradar_Event_Pitch'
  },
  nfl: {
    period_end: 'Integrations_Sportradar_Event_Period_End',
    score_change: 'Integrations_Sportradar_Event_Score_Change',
    touchdown: 'Integrations_Sportradar_Event_Touchdown',
    possession_change: 'Integrations_Sportradar_Event_Possession_Change'
  }
})

export { SportradarEventTypes }



// WEBPACK FOOTER //
// ./src/modules/integrations/types/sportradar/SportradarEventTypes.js